/**
 * 接口地址的统一管理
 */
const base = {
  url: process.env.VUE_APP_BASE_API,
  url_im: process.env.VUE_APP_BASE_API
};
export default {
  //白名单查询
  whiteLit: {
    query: `${base.url}/mis/white/list`,
    addOrUpdate: `${base.url}/mis/white/addOrUpdate`,
    deleteBatchIds: `${base.url}/mis/white/deleteBatchIds`,
  },
  //信用等级查询
  creditLevel: {
    query: `${base.url}/mis/creditlevel/list`,
    logQuery: `${base.url}/mis/creditlevel/logList`,
    download: `${base.url}/mis/creditlevel/downloadCreditLevel`,
    uploadTemplate: `${base.url}/mis/creditlevel/uploadTemplate`,
    addOrUpdate: `${base.url}/mis/creditlevel/edit`,
    deleteBatchIds: `${base.url}/mis/white/deleteBatchIds`,
  },
  //星级查询
  starLevel: {
    query: `${base.url}/mis/starlevel/list`,
    logQuery: `${base.url}/mis/starlevel/logList`,
    addOrUpdate: `${base.url}/mis/starlevel/edit`,
    download: `${base.url}/mis/starlevel/downloadStarLevel`,
    uploadTemplate: `${base.url}/mis/starlevel/uploadTemplate`,
  },
  //人脸配置
  face: {
    recordQuery: `${base.url}/cloud/faceRecord/list`,
    statisticsQuery: `${base.url}/cloud/faceStatistics/list`,
    download: `${base.url}/cloud/faceRecord/export`,
    channelQuery: `${base.url}/cloud/faceChannel/list`,
    channelEdit: `${base.url}/cloud/faceChannel/edit`,
    channelStatus: `${base.url}/cloud/faceChannel/status`,
    channeldel: `${base.url}/cloud/faceChannel/del`,
    channelMap: `${base.url}/cloud/faceChannel/getMapKey`,
    channelSetChannel: `${base.url}/cloud/faceChannel/setChannel`,
    channelLogExport: `${base.url}/cloud/faceChannel/export`,
    configList: `${base.url}/cloud/faceSwitch/list`,
    configEdit: `${base.url}/cloud/faceSwitch/edit`,
    configdel: `${base.url}/cloud/faceSwitch/del`,
    switchCodeEdit: `${base.url}/cloud/faceSwitch/batchUpdateSwitchCode`,
    statusEdit: `${base.url}/cloud/faceSwitch/batchUpdateStatus`,
  },
  registeruserlog: {
    query: `${base.url}/mis/tregisteruserlog/list`,
    down: `${base.url}/mis/tregisteruserlog/export`,
  },
  registervalidate: {
    query: `${base.url}/mis/tregistervalidatelog/list`,
    export: `${base.url}/mis/tregistervalidatelog/export`,
  },
  riskchecktarget: {
    query: `${base.url}/mis/riskchecktarget/list`,
    edit: `${base.url}/mis/riskchecktarget/edit`,
    delete: `${base.url}/mis/riskchecktarget/del`,
  },
  riskcheckrule: {
    query: `${base.url}/mis/riskcheckrule/list`,
    edit: `${base.url}/mis/riskcheckrule/edit`,
    delete: `${base.url}/mis/riskcheckrule/del`,
  },
  riskSWitch: {
    query: `${base.url}/mis/riskchecktarget/riskSwitchList`,
    edit: `${base.url}/mis/riskchecktarget/editRiskSwitch`,
  },
  tracker: {
    query: `${base.url}/mis/ttracker/list`,
    export: `${base.url}/mis/ttracker/export`,
  },
  advertising: {
    query: `${base.url}/mis/advertising/list`,
    edit: `${base.url}/mis/advertising/edit`,
    save: `${base.url}/mis/advertising/save`,
    del: `${base.url}/mis/advertising/del`,
    getData: `${base.url}/mis/advertising/getData`,
    upload: `${base.url}/cloud/file/uploadImage`,
    configQuery: `${base.url}/mis/advertisingConfig/list`,
    configEdit: `${base.url}/mis/advertisingConfig/edit`,
    configSave: `${base.url}/mis/advertisingConfig/save`,
    configDel: `${base.url}/mis/advertisingConfig/del`,
    channelAppQuery: `${base.url}/mis/advertisingChannelApp/list`,
    channelAppEdit: `${base.url}/mis/advertisingChannelApp/edit`,
    channelAppSave: `${base.url}/mis/advertisingChannelApp/save`,
    channelAppDel: `${base.url}/mis/advertisingChannelApp/del`,
    channelAppGetData: `${base.url}/mis/advertisingChannelApp/getData`,
  },
  //返利活动
  rebateActivity: {
    list: `${base.url}/mis/rebate/list`,
    proposalList: `${base.url}/mis/rebate/proposalList`,
    save: `${base.url}/mis/rebate/save`,
    edit: `${base.url}/mis/rebate/edit`,
    applyProposal: `${base.url}/mis/rebate/applyProposal`,
    disableProposal: `${base.url}/mis/rebate/disableProposal`,
    cancelProposal: `${base.url}/mis/rebate/cancelProposal`,
    downloadActivity: `${base.url}/mis/rebate/downloadActivity`,
    downloadProActivity: `${base.url}/mis/rebate/downloadProActivity`,
  },
  //返利记录
  tradingRebate: {
    effectiveCustomerList: `${base.url}/mis/tradingRebate/effectiveCustomerList`,
    tradeDetailsList: `${base.url}/mis/tradingRebate/tradeDetailsList`,
    tradeLogList: `${base.url}/mis/tradingRebate/tradeLogList`,
    downloadTradeDetails: `${base.url}/mis/tradingRebate/downloadTradeDetails`,
    downloadEffectiveCustomer: `${base.url}/mis/tradingRebate/downloadEffectiveCustomer`,
  },
  //入账提交
  depositDetails: {
    list: `${base.url}/mis/depositDetails/list`,
    proposalList: `${base.url}/mis/depositDetails/proposalList`,
    submitProposal: `${base.url}/mis/depositDetails/submitProposal`,
    cancelProposal: `${base.url}/mis/depositDetails/cancelProposal`,
    approvalProposal: `${base.url}/mis/depositDetails/approvalProposal`,
    refuseProposal: `${base.url}/mis/depositDetails/refuseProposal`,
    edit: `${base.url}/mis/depositDetails/edit`,
    downloadList: `${base.url}/mis/depositDetails/downloadList`,
    downloadLimit: `${base.url}/mis/depositDetails/downloadLimit`,
    getTotalAmount: `${base.url}/mis/depositDetails/getTotalAmount`,
  },
  //客户推荐关系
  customerRelation: {
    list: `${base.url}/mis/customerRelation/list`,
    cancelProposal: `${base.url}/mis/customerRelation/cancelProposal`,
    approvalProposal: `${base.url}/mis/customerRelation/applyProposal`,
    edit: `${base.url}/mis/customerRelation/edit`,
    downloadList: `${base.url}/mis/customerRelation/downloadList`,
    downloadProList: `${base.url}/mis/customerRelation/downloadProList`,
  },
  kcharts:{
    scoreList: `${base.url}/mis/kcharts/queryScoreList`,
    tradeList: `${base.url}/mis/kcharts/queryTradeLogList`,
  },
  active:{
    type:{
      query: `${base.url}/mis/activetemplatetype/list`,
      queryAll: `${base.url}/mis/activetemplatetype/listAll`,
      save: `${base.url}/mis/activetemplatetype/save`,
      edit: `${base.url}/mis/activetemplatetype/edit`,
      del: `${base.url}/mis/activetemplatetype/del`,
    },
    active:{
      query: `${base.url}/mis/activetemplate/list`,
      queryById: `${base.url}/mis/activetemplate/queryById`,
      queryDetail: `${base.url}/mis/activetemplate/queryDetail`,
      editDetail: `${base.url}/mis/activetemplate/editDetail`,
      delDetail: `${base.url}/mis/activetemplate/delDetail`,
      save: `${base.url}/mis/activetemplate/save`,
      edit: `${base.url}/mis/activetemplate/edit`,
      del: `${base.url}/mis/activetemplate/del`,
    },
  },
  regAct:{
    week: `${base.url}/mis/regActDetailReport/queryByWeek`,
  },
  smsType:{
    list: `${base.url}/mis/smsType/getSmsType`,
    edit: `${base.url}/mis/smsType/setSmsType`,
  },
  email:{
    templateQuery: `${base.url}/mis/email/templateList`,
    deleteTemplateId: `${base.url}/mis/email/deleteTemplateId`,
    changeEnabled: `${base.url}/mis/email/changeEnabled`,
    addOrUpdateTemplate: `${base.url}/mis/email/editTemplate`,
    getEmailTemplateById: `${base.url}/mis/email/getEmailTemplateById`,
    uploadImgForEmail: `${base.url}/mis/public/uploadImgForEmail`,
    logQuery: `${base.url}/mis/email/logList`,
    deleteLogId: `${base.url}/mis/email/deleteLogId`,
    getTemplateList: `${base.url}/mis/email/getTemplateList`,
    addEmailLog: `${base.url}/mis/email/addEmailLog`,
    getEmailLogById: `${base.url}/mis/email/getEmailLogById`,
    uploadReceiver: `${base.url}/mis/email/uploadReceiver`,
    downloadReceiverInCsv: `${base.url}/mis/email/downloadReceiverInCsv`,
    downloadReceiverInTxt: `${base.url}/mis/email/downloadReceiverInTxt`,
    getAttachmentList: `${base.url}/mis/email/getAttachmentList`,
    downloadAttachment: `${base.url}/mis/email/downloadAttachment`,
    channelQuery: `${base.url}/mis/email/channelList`,
    deleteChannelId: `${base.url}/mis/email/deleteChannelId`,
    changeChannelEnabled: `${base.url}/mis/email/changeChannelEnabled`,
    addOrUpdateChannel: `${base.url}/mis/email/editChannel`,
    getChannelList: `${base.url}/mis/email/getChannelList`,
  },
  agent:{
    query: `${base.url}/mis/agent/query`,
    export: `${base.url}/mis/agent/export`,
    download: `${base.url}/mis/agent/download`,
    validate: `${base.url}/mis/agent/validate`,
  },
  appProduct:{
    // gts2ProductList: `${base.url}/mis/app/product/gts2`,
    metaData: `${base.url}/mis/app/product/meta`,
    appProductList: `${base.url}/mis/app/product/list`,
    add: `${base.url}/mis/app/product/add`,
    update: `${base.url}/mis/app/product/update`,
    delete: `${base.url}/mis/app/product/delete`,
    getCallbackAppProductAmount: `${base.url}/mis/app/product/amount`,
    setCallbackAppProductAmount: `${base.url}/mis/app/product/setAmount`,
  },
  optional:{
    getCountryDictParamList: `${base.url}/mis/optional/getCountryDictParamList`,
    list: `${base.url}/mis/optional/list`,
    edit: `${base.url}/mis/optional/edit`,
    delete: `${base.url}/mis/optional/delete`,
  },
  nps:{
    query: `${base.url}/mis/nps/query`,
    comment: `${base.url}/mis/nps/comment`,
    export: `${base.url}/mis/nps/export`,
    exportEncrypted: `${base.url}/mis/nps/export-encrypted`,
    statistic: `${base.url}/mis/nps/statistic`,
    type: `${base.url}/mis/nps/type`,
  },
  lp:{
    query: `${base.url}/mis/lp/query`,
    export: `${base.url}/mis/lp/export`,
    download: `${base.url}/mis/lp/download`,
  },
  feedback: {
    query: `${base.url}/mis/feedback/query`,
    detail: `${base.url}/mis/feedback/detail`,
    export: `${base.url}/mis/feedback/export`,
    validate: `${base.url}/mis/feedback/validate`,
    download: `${base.url}/mis/feedback/download`,
  },
  appRisk:{
    query: `${base.url}/mis/appRisk/list`,
    edit: `${base.url}/mis/appRisk/edit`,
    del: `${base.url}/mis/appRisk/del`,
    changeStatus: `${base.url}/mis/appRisk/changeStatus`,
  },
  appRiskArticle:{
    query: `${base.url}/mis/appRiskArticle/list`,
    edit: `${base.url}/mis/appRiskArticle/edit`,
    del: `${base.url}/mis/appRiskArticle/del`,
  },
  appRiskCustomer:{
    query: `${base.url}/mis/appRiskCustomer/list`,
  },
  vpnConfig: {
    query: `${base.url}/mis/vpn/query`,
    querySetting: `${base.url}/mis/vpn/setting`,
    submit: `${base.url}/mis/vpn/submit`,
    update: `${base.url}/mis/vpn/update`,
    validate: `${base.url}/mis/vpn/validate`,
    delete: `${base.url}/mis/vpn/delete`
  },
  appAbChannel: {
    query: `${base.url}/mis/app-ab-channel/page`,
    save: `${base.url}/mis/app-ab-channel/save`,
    update: `${base.url}/mis/app-ab-channel/update`,
    delete: `${base.url}/mis/app-ab-channel/delete/`,
    export: `${base.url}/mis/app-ab-channel/export/`,
    import: `${base.url}/mis/app-ab-channel/import`,
    blacklistQuery: `${base.url}/mis/app-ab-channel/blacklist/list`,
    blacklistAdd: `${base.url}/mis/app-ab-channel/blacklist/add`,
    blacklistDelete: `${base.url}/mis/app-ab-channel/blacklist/delete/`,
  },
  cnAreaDict: {
    list: `${base.url}/mis/cn-area-dict/list`,
  },
  appChannel: {
    query: `${base.url}/mis/app-channel/page`,
    save: `${base.url}/mis/app-channel/save`,
    update: `${base.url}/mis/app-channel/update`,
    delete: `${base.url}/mis/app-channel/delete/`,
    client: `${base.url}/mis/app-channel/clients`,
  }
};


